import { Component, Input, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subject, first, skip, takeUntil } from 'rxjs';
import { Category } from 'src/app/models/Category';
import { Pagination } from 'src/app/models/Pagination';
import { Product } from 'src/app/models/Product';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { PreloadAndMulticastService } from 'src/app/services/preload-and-multicast.service';
import { ProductService } from 'src/app/services/product.service';
import { ProductFilterGroup } from '../../classes/ProductFilterGroup';
import { ProductFilter } from '../../classes/ProductFilter';
import { ProductSearchFilters } from '../../classes/ProductSearchFilters';
import { AsyncPaginatorData } from '../../classes/AsyncPaginatorData';
import { RouterService } from 'src/app/services/router-service.service';
import { ProductSearchPageSize } from '../../classes/ProductSearchPageSize';
import { ErrorService } from 'src/app/services/error.service';
import { CompanyValues } from 'src/app/helpers/CompanyValues';
import { ProductFilterArrayBuilder } from '../../classes/ProductFilterArrayBuilder';

@Component({
	selector: 'app-product-search',
	templateUrl: './product-search.component.html',
	styleUrls: ['./product-search.component.scss']
})
export class ProductSearchComponent implements OnDestroy {

	productsPagination : Pagination<Product>;
	filterGroups! : ProductFilterGroup[];
	apd = new AsyncPaginatorData(1, ProductSearchPageSize);
	activeFilters! : ProductFilter[];
	searchInput? : string;

	filtersLoading = false;
	productsLoading = false;

	categories! : Category[];
	companyValues = CompanyValues;

	loggedUserStoreId? : number

	/**
	 * Para la vista de productos de un store. Se le pasa store id solo en StoreProductsPageComponent. Si esta variable está seteada, todas las consultas van a salir con store_id
	 */
	@Input() store_id? : number;
	destroyed = new Subject<void>();
	@ViewChild("containerProducts") containerProducts! : ElementRef

	constructor(private activatedRoute: ActivatedRoute,
				private productService:ProductService,
				private pam:PreloadAndMulticastService,
				private auth:AuthService,
				private routerService:RouterService,
				private errorService:ErrorService) {
					
		this.pam.oCategories.pipe(first()).subscribe(c=> this.categories = c);
		this.auth.oUser.subscribe(u=> {
			if (u && u.is_store && u.store) {
				this.loggedUserStoreId = u.store.id;
			}
		})

		let psf : ProductSearchFilters = this.activatedRoute.snapshot.data["filters"];
		this.getFiltersData(psf);

		this.productsPagination = this.activatedRoute.snapshot.data["productsPagination"];

		this.searchInput = this.activatedRoute.snapshot.queryParams["i"];

		// Esto es para detectar cambios en los query parameters
		// Cada interacciónc on los filtros debería estar cambiando los query parameters y corriendo este evento
		// skip 1 es porque salta al principio cuando se suscribe al cambio en los query parameters
		this.activatedRoute.queryParams.pipe(skip(1), takeUntil(this.destroyed)).subscribe((params: Params) =>{
			this.searchInput = params["i"];
			this.activeFilters = ProductFilterArrayBuilder(this.categories, params);

			this.queryProductsAndFilters();
		});
	}

	ngOnDestroy(): void {
		this.filterGroups = [];
		this.activeFilters = [];
		this.searchInput = undefined;
		this.destroyed.next();
	}

	private getFiltersData(psf: ProductSearchFilters) {
		this.filterGroups = psf.availables;
		this.activeFilters = psf.current;
		
		if (this.activeFilters == undefined || this.activeFilters == null) {
			this.activeFilters = [];
		}
	}

	//#region Consultar
	onPageChange(apd:AsyncPaginatorData) {
		this.apd = apd;
		this.queryProducts();
	}
	private queryProductsAndFilters() {
		this.apd.page = 1;
		this.filtersLoading = true;

		this.productService.getFilters(this.activeFilters, this.searchInput, this.store_id).subscribe({
			next: (psf:ProductSearchFilters)=> {
				this.getFiltersData(psf);
				this.filtersLoading = false;
			}
		});

		this.queryProducts();
	}
	private queryProducts() {
		this.productsLoading = true;
		this.productService.searchProducts(this.apd, this.activeFilters, this.searchInput, this.store_id).subscribe({
			next: (pp:Pagination<Product>)=> {
				this.productsPagination = pp;
				this.containerProducts.nativeElement.focus();
				setTimeout(() => {
					this.routerService.scrollUp();
				}, 0);
			},
			error: (err:any)=> {
				this.errorService.nonDisruptiveGenericError();
			},
			complete: ()=> {
				this.productsLoading = false;
			}
		});
	}
	//#endregion
}
